// Shared with vite.config.ts, so it must not touch import.meta.env.
export const AUTH_PROVIDER_VALUES = ["", "zitadel", "workos"] as const;

export function assertValidAuthProvider(value: string | undefined): void {
  if (value === undefined) return;
  if ((AUTH_PROVIDER_VALUES as readonly string[]).includes(value)) return;
  throw new Error(
    `VITE_AUTH_PROVIDER must be empty, "zitadel" or "workos"; got ${JSON.stringify(value)}`,
  );
}
